import config from '../config';

export function normalizeAttachment(att) {
  if (!att) return null;
  if (typeof att === 'string') {
    const url = att;
    const name = url.split('/').pop() || 'file';
    const ext = name.includes('.') ? name.split('.').pop().toLowerCase() : '';
    let type = 'file';
    if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)) type = 'image';
    else if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(ext)) type = 'video';
    return { url, name, type };
  }
  return {
    url: att.url,
    name: att.name || 'file',
    type: att.type || 'file',
  };
}

export function resolveSupportAttachmentUrl(att) {
  const n = normalizeAttachment(att);
  if (!n?.url) return null;
  const raw = n.url;
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;

  const customerBase =
    (config.customerApiBase || 'http://localhost:8003/api/customer').replace(/\/api\/customer\/?$/, '');
  const b2bPublic = (config.dashB2bPublicUrl || 'https://devbusiness.unloadin.com').replace(/\/$/, '');

  if (raw.startsWith('/static/')) return `${customerBase}${raw}`;
  if (raw.startsWith('/uploads/')) return `${b2bPublic}${raw}`;
  return `${customerBase}${raw.startsWith('/') ? raw : `/${raw}`}`;
}
